import { put, select } from 'redux-saga/effects';
import { navigate } from '@reach/router';
import { WS_ACTION_TYPES } from '../actionTypes';
import { subscriptions } from '../../constants/index';

const {
  loadListSubscription,
  loadDetailSubscription,
  updateDetailSubscription,
  loadRoutesSubscription,
  selectedRouteSubscription,
  loadRouteWayPointDetails,
  loadFavoriteList,
  loadRecentList,
  loadQuickLinks,
  loadTurnByTurn,
  loadDialogContinue,
  loadDialogCancel,
} = subscriptions;

export const connectionWs = ({ connection }) => connection.ws;

const parseWsData = ({ data }) => {
  const { message, name } = JSON.parse(data);
  return {
    message,
    name,
  };
};

export function* initWs() {
  try {
    const ws = yield select(connectionWs);
    ws.onopen = () => console.log('connection open');
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* poiList({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = loadListSubscription;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* poiDetail({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = loadDetailSubscription;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* poiDetailUpdate({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      if (name === updateDetailSubscription) {
        payload(message, ws);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* routeList({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      if (name === loadRoutesSubscription) {
        payload(message, ws);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* dropRouteList({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = selectedRouteSubscription;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* routeWaypointDetails({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = loadRouteWayPointDetails;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* favoriteList({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = loadFavoriteList;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* recentList({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = loadRecentList;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* quickLinks({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = loadQuickLinks;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* turnByTurnRoutes({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name, message } = parseWsData(event);
      const { action, routeScreen } = loadTurnByTurn;
      if (name === action) {
        payload(message, ws);
        navigate(routeScreen);
      }
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* dialogContinue({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name } = parseWsData(event);
      const { action } = loadDialogContinue;
      if (name === action) payload();
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* dialogCancel({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.addEventListener('message', event => {
      const { name } = parseWsData(event);
      const { action } = loadDialogCancel;
      if (name === action) payload();
    });
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}

export function* sendGenericMessage({ payload }) {
  try {
    const ws = yield select(connectionWs);
    ws.send(payload);
  } catch (error) {
    yield put({
      type: WS_ACTION_TYPES.WS.ERROR,
    });
  }
}
